import { formatTime } from '../../utils/index'
import { decodeElement } from '../../utils/decodeElement'
import Vue from 'vue'
import TencentCloudChat from '@tencentcloud/chat';

const conversationModules = {
  state: {
    allConversation: [], // 所有的conversation
    currentConversationID: '', // 当前聊天对话ID
    currentConversation: {}, // 当前聊天对话信息
    currentMessageList: [], // 当前聊天消息列表
    nextReqMessageID: '', // 下一条消息标志
    isCompleted: false, // 当前会话消息是否已经请求完毕
    isLoading: false, // 是否正在请求
    selectedMember: [], // 选中的群成员
	systemUnreadCount: 0 ,//系统消息未读数量（数据库消息）
	systemLastMsg: {}, //系统消息最新一条 (数据库消息)
	positionId:'',
  },
  getters: {
    allConversation: state => state.allConversation,
    systemUnreadCount: state => state.systemUnreadCount,
    // 当前聊天对象的ID
    toAccount: state => {
      if (state.currentConversationID.indexOf('C2C') === 0) {
        return state.currentConversationID.substring(3)
      } else if (state.currentConversationID.indexOf('GROUP') === 0) {
        return state.currentConversationID.substring(5)
      }
    },
    // 当前聊天对象的昵称
    toName: state => {
      if (state.currentConversation.type === 'C2C') {
        return state.currentConversation.userProfile.nick
      } else if (state.currentConversation.type === 'GROUP') {
        return state.currentConversation.groupProfile.name
      }
    },
    // 当前聊天对话的Type
    currentConversationType: state => {
      if (state.currentConversationID.indexOf('C2C') === 0) {
        return 'C2C'
      }
      if (state.currentConversationID.indexOf('GROUP') === 0) {
        return 'GROUP'
      }
      return ''
    },
    currentConversation: state => state.currentConversation,
    currentMessageList: state => state.currentMessageList,
    totalUnreadCount: state => {
		const result = state.allConversation.reduce((count, { unreadCount }) => count + unreadCount, 0)
		return (result)
    }
  },
  mutations: {
	//系统消息未读数改变
	changeSystemUnreadCount(state, num){
		state.systemUnreadCount = num
	},
	changeSystemLastMsg(state, systemLastMsg){
		state.systemLastMsg = systemLastMsg
	},
    // 历史头插消息列表
    // 小程序问题，在渲染的时候模板引擎不能处理函数，所以只能在渲染前处理好message的展示问题
    unshiftMessageList (state, messageList) {
      let list = [...messageList]
      for (let i = 0; i < list.length; i++) {
        let message = list[i]
        // list[i].virtualDom = decodeElement(message)
        let date = new Date(message.time * 1000)
        list[i].newtime = formatTime(date)
      }
      state.currentMessageList = [...list, ...state.currentMessageList]
    },
    // 收到
    receiveMessage (state, messageList) {
      let list = [...messageList]
      for (let i = 0; i < list.length; i++) {
        let message = list[i]
        list[i].virtualDom = decodeElement(message)
        let date = new Date(message.time * 1000)
        list[i].newtime = formatTime(date)
		console.log(message)
		if(message.conversationID == state.currentConversationID){
			Vue.prototype.tim.setMessageRead({ conversationID:message.conversationID })
		}
      }
      state.currentMessageList = [...state.currentMessageList, ...list]
    },
    sendMessage (state, message) {
      message.virtualDom = decodeElement(message)
      let date = new Date(message.time * 1000)
      message.newtime = formatTime(date)
      state.currentMessageList.push(message)
    },
    // 更新当前的会话
    updateCurrentConversation (state, conversation) {
      state.currentConversation = conversation
      state.currentConversationID = conversation.conversationID
    },
    updateSelectedMember (state, memberList) {
      state.selectedMember = memberList
    },
    // 更新当前所有会话列表
    updateAllConversation (state, list) {
		let newList = []
		for (let i = 0; i < list.length; i++) {
			if (list[i].lastMessage && (typeof list[i].lastMessage.lastTime === 'number')) {
			  let date = new Date(list[i].lastMessage.lastTime * 1000)
			  list[i].lastMessage._lastTime = formatTime(date)
			}
			if(list[i].conversationID != 'C2Cadministrator'&&list[i].lastMessage.fromAccount){
				newList.push(list[i])
			}
		}
      // state.allConversation = newList
      state.allConversation = list
    },
    // 重置当前会话
    resetCurrentConversation (state) {
      state.currentConversationID = '' // 当前聊天对话ID
      state.currentConversation = {} // 当前聊天对话信息
      state.currentMessageList = [] // 当前聊天消息列表
      state.nextReqMessageID = '' // 下一条消息标志
      state.isCompleted = false // 当前会话消息是否已经请求完毕
      state.isLoading = false // 是否正在请求
      state.selectedMember = []
	  state.positionId = ''
    },
    resetAllConversation (state) {
      state.allConversation = []
    },
    removeMessage (state, message) {
      state.currentMessageList.splice(state.currentMessageList.findIndex(item => item.ID === message.ID), 1)
    },
    changeMessageStatus (state, index) {
      state.currentMessageList[index].status = 'fail'
    },
	updatePositionId(state,id){
		state.positionId = id
	},
  },
  actions: {
	  // 消息已读
	  onMessageRead(context, event) {
		  let {data} = event
			data.forEach(item=>{
				if(item.conversationID == context.state.currentConversationID){
					let current = context.state.currentMessageList.find(currentItem => currentItem.ID == item.ID)
					if(current) current.isPeerRead = true
				}
			})
	  },
    // 消息事件
    onMessageEvent (context, event) {
      if (event.name === 'onMessageReceived') {
        let id = context.state.currentConversationID
        if (!id) {
          return
        }
        let list = []
        event.data.forEach(item => {
          if (item.conversationID === id) {
            list.push(item)
          }
        })
        context.commit('receiveMessage', list)
      }
    },
    
	// 获取消息列表
    getMessageList (context) {
      const {currentConversationID, nextReqMessageID} = context.state
      // 判断是否拉完了，isCompleted 的话要报一下没有更多了
      if (!context.state.isCompleted) {
        // 如果请求还没回来，又拉，此时做一下防御
        if (!context.state.isLoading) {
          context.state.isLoading = true
          Vue.prototype.tim.getMessageList({ conversationID: currentConversationID, nextReqMessageID: nextReqMessageID, count: 15 }).then(res => {
            context.state.nextReqMessageID = res.data.nextReqMessageID
            context.commit('unshiftMessageList', res.data.messageList)
            if (res.data.isCompleted) {
              context.state.isCompleted = true
            }
            context.state.isLoading = false
    		return true
          }).catch(err => {
			return true
          })
        } else {
    		return true
        }
      } else {
		return false	
      }
    },
   
	checkoutConversation (context, item) {
		let conversationID = item.conversationID
		context.commit('resetCurrentConversation')
		Vue.prototype.tim.setMessageRead({ conversationID })
		return Vue.prototype.tim.getConversationProfile(conversationID).then(({ data: { conversation } }) => {
			console.log('conversation------',conversation)
			context.commit('updateCurrentConversation', conversation)
			context.dispatch('getMessageList')
			if(item.position_id) context.commit('updatePositionId',item.position_id)
			if(!conversation.lastMessage.messageForShow&&item.position_id){
				const message = Vue.prototype.tim.createCustomMessage({
					to:conversation.conversationID.replace('C2C',''),
					conversationType: TencentCloudChat.TYPES.CONV_C2C,
					payload:{
						description:'firstMsg'
					},
					cloudCustomData:item.position_id.toString()
				})
				Vue.prototype.tim.sendMessage(message).then(res=>{
					context.commit('sendMessage', message)
					return Promise.resolve(true)
				});
			}else{
				return Promise.resolve(true)
			}
		})
	}
  }
}

export default conversationModules
